import { useUser } from '@/hooks/user/useUser';
import { useCheckFeatureAccessQuery } from '@/services/ApiService';

export const SPANISH_TRANSLATION_FEATURE_KEY = 'spanish_translation';

/**
 * Whether this reader may use Spanish: the signed-in user holds the Early Access feature (opted into
 * Early Access, or granted by an admin). This is the only gate on Spanish in the app. Signed out is
 * never allowed — the feature check needs a user.
 *
 * `denied` is true only once that is known, not while the user or the access check is still loading,
 * so a caller can act on it (put the reader back to English) without doing so to a beta user whose
 * session has not loaded yet.
 */
export const useSpanishTranslationAccess = () => {
    const { user, isLoading: userLoading } = useUser();
    const { data, isLoading: accessLoading, isError: accessFailed } = useCheckFeatureAccessQuery(SPANISH_TRANSLATION_FEATURE_KEY, {
        skip: !user,
    });

    const enabled = data?.hasAccess === true;
    // A failed check counts as an answer, and the answer is no: left unsettled it would keep the
    // interface English while the cookie kept the API in Spanish.
    const settled = !userLoading && (!user || (!accessLoading && (data !== undefined || accessFailed)));

    return {
        enabled,
        denied: settled && !enabled,
    };
};
